export const processNodeInformation = ({ response, tile, setState }) => {
  if (!Array.isArray(response)) {
    setState([]);
    return;
  }

  const nodes = tile?.getNodes?.() || [];

  const infoArr = response
    .map((res, idx) => {
      const meta = res?.body?.meta_data;
      const node = nodes[idx];

      if (meta) {
        return {
          nodeName: node?.getName?.() || "",
          tsid: meta?.tsid || "",
          nodeId: meta?.source || "",
        };
      }

      if (res?.body?.tsid) {
        return {
          nodeName: node?.getName?.() || "",
          tsid: res.body.tsid,
          nodeId: node?.getId?.() || "",
        };
      }

      return null;
    })
    .filter(Boolean) as Array<{
    nodeName: string;
    tsid: string;
    nodeId: string;
  }>;

  setState(infoArr);
};
